import { Controller } from "@hotwired/stimulus"

/**
 * Link Feedback Controller
 * 
 * Provides visual feedback for link actions, particularly for upscaling and remeasure operations.
 * Shows loading spinners and hides content during processing.
 * 
 * Features:
 * - Shows loading spinner during upscaling operations
 * - Shows loading spinner during remeasure operations
 * - Hides content and shows spinner during processing
 * - Provides consistent loading state management
 * 
 * Usage: Add data-controller="link-feedback" to links that need loading feedback with content and spinner targets
 */
export default class extends Controller {
  static targets = ["content", "spinner"]

  upscale() {
    if (this.hasContentTarget && this.hasSpinnerTarget) {
      this.contentTarget.classList.add("d-none")
      this.spinnerTarget.classList.remove("d-none")
    }
  }

  remeasure() {
    if (this.hasContentTarget && this.hasSpinnerTarget) {
      this.contentTarget.classList.add("d-none")
      this.spinnerTarget.classList.remove("d-none")
    }
  }
} 